export const INITIAL_OFFERS_REQUEST_QUERY = 'Новостройки ПИК';
